import { RefObject, useCallback } from 'react';

import TableBottomLoader from '#/components/tables/TableBottomLoader';
import { useWsStatus } from '@paradigm/features/src/unified-rfqs/contexts/use-ws-status';
import {
  useUnifiedOpenOrdersFetchData,
  useUnifiedOpenOrdersService,
} from '@paradigm/features/src/unified-rfqs/contexts/unified-orders';
import { toast } from '#/components/UnifiedRfqs/toast';
import { useDebouncedTrackAction } from '@paradigm/features/src/analytics';

interface Props {
  readonly scrollableRef: RefObject<HTMLElement>;
}

export default function BottomLoader(props: Props) {
  const { scrollableRef } = props;
  const { canFetchMore, status } = useUnifiedOpenOrdersFetchData();
  const { fetcher } = useUnifiedOpenOrdersService();
  const { subscribing, connected } = useWsStatus();
  const trackAction = useDebouncedTrackAction();

  const handleFetchMore = useCallback(() => {
    trackAction('load more items');
    const onError = ({ message }: { message: string }) => {
      toast(message);
    };

    fetcher.fetchMore({}, onError);
  }, [fetcher, trackAction]);

  return (
    <TableBottomLoader
      disabled={!canFetchMore}
      isLoading={!connected || subscribing || status !== 'idle'}
      scrollableRef={scrollableRef}
      onFetchMore={handleFetchMore}
    />
  );
}
